export default function urlizer(str = '') {
  return str.replace(/[^A-Z0-9]+/gi, '-').toLocaleLowerCase()
}
